import { __extends } from "tslib";
import { Injectable } from '@angular/core';
import { IonicNativePlugin, checkAvailability, cordovaInstance, getPromise } from '@ionic-native/core';
var SecureStorageObject = /** @class */function () {
  function SecureStorageObject(_objectInstance) {
    this._objectInstance = _objectInstance;
  }
  SecureStorageObject.prototype.get = function (key) {
    return cordovaInstance(this, "get", {
      "callbackOrder": "reverse"
    }, arguments);
  };
  SecureStorageObject.prototype.set = function (key, value) {
    return cordovaInstance(this, "set", {
      "callbackOrder": "reverse"
    }, arguments);
  };
  SecureStorageObject.prototype.remove = function (key) {
    return cordovaInstance(this, "remove", {
      "callbackOrder": "reverse"
    }, arguments);
  };
  SecureStorageObject.prototype.keys = function () {
    return cordovaInstance(this, "keys", {
      "callbackOrder": "reverse"
    }, arguments);
  };
  SecureStorageObject.prototype.clear = function () {
    return cordovaInstance(this, "clear", {
      "callbackOrder": "reverse"
    }, arguments);
  };
  SecureStorageObject.prototype.secureDevice = function () {
    return cordovaInstance(this, "secureDevice", {}, arguments);
  };
  return SecureStorageObject;
}();
export { SecureStorageObject };
var SecureStorage = /** @class */function (_super) {
  __extends(SecureStorage, _super);
  function SecureStorage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  SecureStorage.prototype.create = function (store) {
    var _this = this;
    return function () {
      if (checkAvailability(_this) === true) {
        return getPromise(function (res, rej) {
          var instance = new (SecureStorage.getPlugin())(function () {
            return res(new SecureStorageObject(instance));
          }, function () {
            return rej(new SecureStorageObject(instance));
          }, store);
        });
      }
    }();
  };
  SecureStorage.pluginName = "SecureStorage";
  SecureStorage.plugin = "cordova-plugin-secure-storage-echo";
  SecureStorage.pluginRef = "cordova.plugins.SecureStorage";
  SecureStorage.repo = "https://github.com/mibrito707/cordova-plugin-secure-storage-echo";
  SecureStorage.platforms = ["Android", "Browser", "iOS", "Windows"];
  SecureStorage.decorators = [{
    type: Injectable
  }];
  return SecureStorage;
}(IonicNativePlugin);
export { SecureStorage };
